export default (value: any) => (typeof value === 'string' ? value : undefined);
